import axios from 'axios';

const apiSGA = axios.create({
  baseURL: process.env.REACT_APP_URL_API_SGA,
});

export default apiSGA;
